"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.__DEPRECATED__ToggleField = exports.StyledToggle = void 0;
const react_1 = __importDefault(require("react"));
const clsx_1 = __importDefault(require("clsx"));
require("./Toggle.pc.css");
const StyledToggle = ({ onClick, testId, on }) => {
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)('_f3380a7a', '_ad8ee3f8', '_pub-ad8ee3f8', '_pub-3c25d522', '_ad8ee3f8___checkbox-input', '_pub-ad8ee3f8___checkbox-input', '_pub-3c25d522___checkbox-input', '__checkbox-input', { '_ad8ee3f8_on _pub-ad8ee3f8_on _pub-3c25d522_on on': on }), onClick: onClick, "data-testid": testId, tabIndex: 0, "aria-roledescription": "button" },
        react_1.default.createElement("div", { className: (0, clsx_1.default)('_528c370', '_ad8ee3f8', '_pub-ad8ee3f8', '_pub-3c25d522') }),
        react_1.default.createElement("div", { className: (0, clsx_1.default)('_9c2192ca', '_ad8ee3f8', '_pub-ad8ee3f8', '_pub-3c25d522') }),
        react_1.default.createElement("div", { className: (0, clsx_1.default)('_eb26a25c', '_ad8ee3f8', '_pub-ad8ee3f8', '_pub-3c25d522') })));
};
exports.StyledToggle = StyledToggle;
const __DEPRECATED__ToggleField = ({ onClick, testId, className, children, label, }) => {
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)('_1d366b56', '_ad8ee3f8', '_pub-ad8ee3f8', '_pub-3c25d522', className), onClick: onClick, "data-testid": testId },
        children,
        react_1.default.createElement("label", { className: (0, clsx_1.default)('_9fa546a4', '_ad8ee3f8', '_pub-ad8ee3f8', '_pub-3c25d522') }, label)));
};
exports.__DEPRECATED__ToggleField = __DEPRECATED__ToggleField;
//# sourceMappingURL=Toggle.pc.js.map